export function gallerySlider() {
    let $galleryContainer = $(".gallery");
    let $galleryPicture = $galleryContainer.find(".gallery-img");
    let $galleryThumb = $galleryContainer.find(".gallery-thumb");

    $galleryPicture.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: false,
        asNavFor: ".gallery-thumb",
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                }
            }
        ]
    });

    $galleryThumb.slick({
        slidesToScroll: 1,
        slidesToShow: 2.12,
        asNavFor: ".gallery-img",
        dots: false,
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        mobileFirst: true,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    arrows: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $galleryThumb.on("afterChange", function (event, slick, currentSlide) {
        $(this)[`${slick.$slides.length <= slick.options.slidesToShow + currentSlide ? 'add' : 'remove'}Class`]("last-slider");
    });
}








// WEBPACK FOOTER //
// ./assets/js/modules/gallerySlider.js